<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<div class="og-container">
  <mat-card-title class="container__title">
    {{ title }}
    @if (isEditable && !isLoading) { @if (!isEditModeActive) {
    <i class="material-icons title__icon" (click)="isEditModeActive = true">
      mode_edit
    </i>
    } @if (isEditModeActive) {
    <i class="material-icons title__icon" (click)="isEditModeActive = false">
      close
    </i>
    } }
  </mat-card-title>

  @if (isLoading) {
  <div class="container__spinner">
    <mat-progress-spinner
      [mode]="'indeterminate'"
      [color]="'accent'"
      [diameter]="60"
    ></mat-progress-spinner>
  </div>
  } @else { @if (!isEditModeActive || !isEditable) {
  <div class="container__display-view">
    <ng-content select="[display-view]"></ng-content>
  </div>
  } @else {
  <div class="edit-view">
    <ng-content select="[edit-view]"></ng-content>
    <div class="edit-view__save">
      <button mat-raised-button color="accent" (click)="propagateSaveButtonClick()">
        Save
      </button>
    </div>
  </div>
  } }
</div>
